// mui
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const RootStyles = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.neutral,
}));


export default function OfferNoResponse() {

  return (
    <RootStyles>
      <Typography variant="body2">
        응답이 없으셔서 다른 크루와 매칭되었습니다.
      </Typography>
    </RootStyles>
  )
}
